import { FilterOption } from '../../../../../ui-components/lib/filter-dropdown/filter-dropdown.model';
import { TableFilterTab } from '../../../../../ui-components/lib/table/table.model';
import { RequestTypeEnum } from '../../../../common/enums/request-type';
import { ActionList } from '../../../../common/models/action-list.model';
import { EMPLOYEE_ROUTES } from '../../../../common/constants/employee.routing.constants';
import { ENDPOINTS } from '../../../../common/constants/endpoints.constants';
import { FilterMapping } from '../../../../../ui-components/lib/filter-dropdown/filter-mapping.enum';
import { RELATED_REQUESTS_COLUMN_HEADER } from '../../const';

export const ON_HOLD_VIEW_DETAILS_ACTION: ActionList = {
  key: 'view_details',
  hasIcon: true,
  label: 'view_details_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
};

export const ON_HOLD_TABLE_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'closed_request_screen_table_filter_all_time_label',
    active: true,
    iconName: 'calendar',
  },
];

export const ON_HOLD_DEFAULT_COLUMNS = [
  {
    header: '',
  },
  {
    header: 'closed_request_screen_table_header_id_title',
    showViewIcon: true,
    viewIconRouterLink: (row: any) => [
      `${EMPLOYEE_ROUTES.MY_ORGANIZATION.REQUEST}/${RequestTypeEnum.ACTION}/${row.id.toString()}`,
    ],
    isSortable: true,
    sortKey: 'request_id][type',
  },
  {
    header: 'closed_request_screen_table_header_request_name_title',
    isSortable: true,
    sortKey: 'workflow_type][type',
  },
  {
    header: 'closed_request_screen_table_header_creation_date_title',
    isSortable: true,
    sortKey: 'creation_date][type',
  },
  {
    header: 'closed_request_screen_table_header_creator_title',
    isSortable: true,
    sortKey: 'creator][type',
  },
  {
    header: 'remaining_time_header_title',
    isSortable: false,
  },
  {
    header: 'closed_request_screen_table_header_request_subject_title',
    isSortable: true,
    sortKey: 'request_subject][type',
  },
  {
    header: 'closed_request_screen_table_header_related_project_title',
    isSortable: true,
    sortKey: 'related_project][type',
  },
  {
    header: 'in_progress_tab_current_step_header_title',
    isSortable: true,
    sortKey: 'current_position][type',
  },
  {
    header: 'in_progress_tab_assignee_header_title',
    isSortable: false,
    sortKey: 'assignee][type',
  },
  {
    header: RELATED_REQUESTS_COLUMN_HEADER,
    isSortable: false,
  },
  {
    header: '',
  },
];

export const ON_HOLD_FILTER_OPTIONS: FilterOption[] = [
  {
    key: 'workflowTypes',
    label: 'closed_request_screen_filter_workflow_types_label',
    type: 'multi',
    apiUrl: ENDPOINTS.filters.workflowType,
    placeholder: 'closed_request_screen_filter_workflow_types_placeholder',
  },
  {
    key: 'creationDate',
    label: 'closed_request_screen_filter_creation_date_label',
    type: 'dateRange',
  },
  {
    key: 'projectIds',
    label: 'vendor_invoice_page_table_filter_option_product',
    type: 'multi',
    apiUrl: ENDPOINTS.Lookup.project,
    placeholder: 'vendor_invoice_page_table_filter_option_product_placeholder',
  },
  {
    key: 'resourceType',
    label: 'filter_resources_type_label',
    type: 'resourceType',
  },
];

export const ON_HOLD_FILTER_MAPPING: Record<string, string> = {
  workflowTypes: FilterMapping.WORKFLOW_TYPES_FLOWS,
  creationDateStart: FilterMapping.CREATED_AFTER_REQUESTS,
  creationDateEnd: FilterMapping.CREATED_BEFORE_REQUESTS,
  status: FilterMapping.PROJECT_STATES,
  projectIds: FilterMapping.PROJECT_IDS,
};
